import createCachedSelector from "re-reselect";

const emptyArray = [];
const defaultActivityFields = {
  isLoaded: false
};

export const getActivityFields = (state, partnerId) => {
  const activityFieldsData = state.entities.offerPartnerActivities[partnerId];
  return activityFieldsData ? activityFieldsData.partnerActivityFields : emptyArray;
};

const getActivityFieldsData = (state, partnerId) =>
  state.currentOffer.clientActivityFieldsData[partnerId] || defaultActivityFields;

export const getActivityFieldsIsLoaded = createCachedSelector(getActivityFieldsData, clientActivityFieldsData => {
  return clientActivityFieldsData.isLoaded;
})((_, partnerId) => partnerId);

export const getOfferActivityFields = createCachedSelector(
  getActivityFieldsIsLoaded,
  getActivityFields,
  (isLoaded, clientActivityFieldsData) => {
    if (!isLoaded) {
      return emptyArray;
    }
    return clientActivityFieldsData;
  }
)((_, partnerId) => partnerId);

export const getActivityFieldsTypes = state =>
  state.entities.activityFieldsTypes
    ? Object.keys(state.entities.activityFieldsTypes).map(i => state.entities.activityFieldsTypes[i])
    : [];
